import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import {
  AdminMenuLayout,
  ModalProductGroups,
} from "../../../shared/components";
import { WrapperCardProductGroups } from "./styled";
import { useProductGroups } from "../hooks";
import { selectModalProductGroups } from "../../../redux";
import { TableProductGroups } from "./TableProductGroups";

export const ProductGroups = () => {
  const modalProductGroups = useSelector(selectModalProductGroups);
  const {
    isUpdateProductGroup,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalProductGroupsState,
  } = useProductGroups();

  return (
    <AdminMenuLayout
      pageDescription="Grupos de Productos"
      title="Grupos de Productos"
    >
      <WrapperCardProductGroups>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalProductGroupsState}
            >
              Agregar nuevo grupo
            </Button>
          </Col>
        </Row>
        <TableProductGroups />
        {modalProductGroups && isUpdateProductGroup && (
          <FormProvider {...formMethodsUpdate}>
            <ModalProductGroups />
          </FormProvider>
        )}
        {modalProductGroups && !isUpdateProductGroup && (
          <FormProvider {...formMethodsCreate}>
            <ModalProductGroups />
          </FormProvider>
        )}
      </WrapperCardProductGroups>
    </AdminMenuLayout>
  );
};
